import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=4f92a3ee&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f92a3ee')) {
      api.createRecord('4f92a3ee', component.options)
    } else {
      api.reload('4f92a3ee', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=4f92a3ee&", function () {
      api.rerender('4f92a3ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22oaMpNuyLMP3/JS/pricehelp.vue"
export default component.exports